import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService, TreeDragDropService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';
import { NgxSpinnerService } from 'ngx-spinner';

import { routes } from './app.routes';
import { httpInterceptorProviders } from './http-interceptors/index';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({ theme: { preset: Aura } }),
    Title,
    NgxSpinnerService,
    ConfirmationService,
    MessageService,
    TreeDragDropService,
    httpInterceptorProviders,
  ],
};
